export default __webpack_public_path__ + "static/media/shaq-shake.b8fdfabc.gif";